"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveDistributionReportOutcome = void 0;
/**
 * The one derivation of a row's outcome, shared by the confirmed report (API) and the review-step
 * preview (web) so the two exports can never disagree on the same allocation.
 */
const deriveDistributionReportOutcome = (allocation) => {
    if (allocation.status === "withheld") {
        switch (allocation.unpaidReason) {
            case "missing_bank":
                return "unpaid_missing_bank";
            case "lapsed_kyc":
                return "unpaid_lapsed_kyc";
            case "admin_blocked":
                return "unpaid_admin_blocked";
            default:
                return "unpaid_suspended";
        }
    }
    return allocation.treatment === "reinvest" ? "reinvest" : "bank_payout";
};
exports.deriveDistributionReportOutcome = deriveDistributionReportOutcome;
//# sourceMappingURL=IDistributionService.js.map